import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DynamicFormField } from '@teamfoster/dynamic-forms';
import { NgClass } from '@angular/common';
import { RouterLink } from '@angular/router';
import { AddressCardComponent } from '../../../account/components/address-card/address-card.component';
import { AlertComponent } from '../../../core/components/alert/alert.component';
import { FromDictionaryPipe } from '@teamfoster/sdk/dictionary-ngrx';

@Component({
  selector: 'app-form-connected-address',
  templateUrl: './form-connected-address.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, RouterLink, AddressCardComponent, AlertComponent, FromDictionaryPipe],
})
export class FormConnectedAddressComponent {
  config!: DynamicFormField;
}
